export default __webpack_public_path__ + "static/media/lgn-sm.a69eabc1.webp";